export * from './mall';

export function loadMine() {
  return {
    type: 'LOAD_MINE',
  };
}

export function loadMineCompletion(data, error) {
  return {
    type: 'LOAD_MINE_COMPLETION',
    data,
    error,
  };
}

export function loadHomeMine(reload) {
  return {
    type: 'LOAD_HOME_MINE',
    reload,
  };
}

export function loadHomeMineCompletion(error, data, didLoadAt) {
  return {
    type: 'LOAD_HOME_MINE_COMPLETION',
    error,
    data,
    didLoadAt,
  };
}
